


























import {
  defineComponent,
  useFetch,
  ref,
  useRoute,
  useContext
} from '@nuxtjs/composition-api';
import { useCache } from '@wemade-vsf/cache';
import { useAttributeCollectionItems } from '@wemade-vsf/attribute-collection';
import type { AttributeCollectionItem } from '@wemade-vsf/magento-api';
import { getMetaInfo } from '@wemade-vsf/core';
import { SfBreadcrumbs, SfHeading } from '@storefront-ui/vue';
import CmsContent from 'components/theme/Content/CmsContent.vue';
import FilterableProductsLayout from 'components/catalog/FilterableProductsLayout.vue';
import { useImage } from '@wemade-vsf/composables';

export default defineComponent({
  name: 'AttributeCollectionItem',
  components: {
    SfBreadcrumbs,
    SfHeading,
    CmsContent,
    FilterableProductsLayout
  },
  setup () {
    const { $config } = useContext();
    const route = useRoute();
    const { addTags } = useCache();
    const { error: nuxtError, i18n, localeRoute } = useContext();
    const { imageSizes, getMagentoImage } = useImage();
    const { loading, error, getItems } = useAttributeCollectionItems();
    const item = ref<AttributeCollectionItem | null>(null)
    const breadcrumbs = ref<Array<{text: string, link: string}>|null>(null)
    const imageHeight = imageSizes.card?.height || 400;
    const imageWidth = imageSizes.card?.width || 400;
    const collectionUrlKey = route.value.params.collection_slug
    const urlKey = route.value.params.slug

    const showSearch = $config.attributeCollection?.searchField ?? false;

    useFetch(async () => {
      const query = {
        filter: {
          is_active: { eq: '1' },
          parent_url_key: { eq: collectionUrlKey },
          url_key: { eq: urlKey }
        }
      }

      const items = await getItems(query)
      item.value = items && items.length ? items[0] : null

      if (error?.value?.getItems || !item.value) nuxtError({ statusCode: 404 })

      addTags([{ prefix: 'ACI', value: collectionUrlKey + '_ ' + urlKey }])
      breadcrumbs.value = [
        { text: i18n.t('Home'), link: localeRoute({ name: 'home'}).fullPath },
        { text: item.value?.collection?.title || '', link: localeRoute({ name: 'attributeCollection', params: { slug: collectionUrlKey } }).fullPath },
        { text: item.value?.title || '', link: localeRoute({ name: 'attributeCollectionItem', params: { slug: urlKey, collection_slug: collectionUrlKey } }).fullPath }
      ]


    })

    return {
      imageHeight,
      imageWidth,
      getMagentoImage,
      loading,
      breadcrumbs,
      item,
      showSearch
    }
  },
  head () {
    return getMetaInfo(this.item)
  }
})
